import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../core'
import * as externalInstitutions from '../external-institutions'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from(
      externalInstitutions.RESOURCE.payload,
    ),
    description: 'Employer identification number (EIN) from the IRS',
    isOptional: true,
    name: 'EIN',
    partialId: PartialId.Standard.create('ein'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
